import React, { useRef, useEffect, useState }       from 'react';
import { Modal, Button, Form }                      from 'react-bootstrap';
import { useDispatch, useSelector }                 from 'react-redux';
import AsyncSelect                                  from 'react-select/async'

import { Formik }                                   from 'formik';
import { setLocale }                                from 'yup';
import * as yup                                     from 'yup';

import { ErrorMessage }                             from '../../extras/toastMessages';
import { ICON_SAVE, ICON_CANCEL }                   from '../../extras/icons';
import { listAudienceMotivesAction }                from '../../../actions/audienceMotivesActions';
import { listJudgesAction }                         from '../../../actions/judgesActions';
import { MOTIVO_RECUSACION }                        from '../../../data/audienceMotivesGroups';
import { saveRecusesAction, updateRecusesAction }   from '../../../actions/recusesActions';

import ButtonSpinner                                from '../../layout/ButtonSpinner';
import clienteAxios                                 from '../../../config/axios';




const RecuseForm = props => {



    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Tomo los props
    const { show, handleClose } = props;

    // Genero los refs
    const refJuez = useRef();

    // Datos iniciales
    const initialData = {
        juez: '',
        expediente: '',
        motivo: ''
    }

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Traigo el store de persona tipos
    const audienceMotives = useSelector( state => state.audienceMotives.audienceMotives );
    const isEdit = useSelector( state => state.recuses.isEdit );
    const judges = useSelector( state => state.judges.judges );
    const recusesLoading = useSelector( state => state.recuses.loadingSave );
    const recuseSelected = useSelector( state => state.recuses.recuseSelected );

    // Inicializo el state local
    const [ expediente, setExpediente ] = useState(null);
    const [ exptError, setExptError ] = useState(null);
    const [ inputValue, setInputValue ] = useState('');
    const [ recuse, setRecuse ] = useState(initialData);



    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && recuseSelected)
        {   setRecuse({
                ...recuseSelected,
                juez: recuseSelected.juez.id,
                expediente: recuseSelected.expediente.id,
                motivo: recuseSelected.motivo.id
            });
        }
        else
        {   setRecuse(initialData);
        }
        //eslint-disable-next-line
    }, [isEdit, recuseSelected, show])

    // Manejo de cambios
    const handleChange = e => {
        setRecuse({
            ...recuse,
            [e.target.name]: e.target.value
        })
    }

    // handle selection
    const handleChangeExpt = value => {
        setExpediente(value);
    }

    // Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setRecuse(initialData);
        setExptError(null);
        setExpediente(null);
        setInputValue('');
        //Cierro
        handleClose();
    }

    // handle input change event
    const handleInputChange = value => {
        setInputValue(value);
    };

    // Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si cargó los jueces
        if(!judges)
        {   dispatch( listJudgesAction({
                search: 'activo:1',
                sort: 'apellido:asc,nombre:asc'
            }) );
        }
        //Me fijo si cargó los tipos
        dispatch( listAudienceMotivesAction({
            search: 'activo:1',
            sort: 'descripcion:asc'
        }) );
        //Pongo el foco en el primer campo
        refJuez.current.focus();
    }

    // Manejo las opciones
    const handleOptions = async (inputValue, callback) => {
        //Hago la búsqueda a partir de cierta longitud
        if(inputValue && inputValue.trim().length > 3)
        {   try{
                //Armo los parámetros
                const params = {
                    search: `numero:${inputValue}`
                }
                //Hago la consulta
                const response = await clienteAxios.get(`/expediente`, { params });
                //Obtengo los datos
                const res = response.data;
                //Retorno
                return callback(res.content);
            }
            catch(error)
            {   const response = error.response;
                let data = {
                    data: null,
                    message: 'Error al conectarse al servidor'
                };
                //Verifico si hay error
                if(response){
                    data = response.data;
                }
                //Mensaje de error
                ErrorMessage(data.message);
            }
            //Retorno
            return callback(null);
        }
    }

    // Manejo el guardado
    const handleSave = values => {
        //Reinicio
        setExptError(null);
        //Valido manualmente el expediente
        if(!expediente || typeof expediente.id === 'undefined')
        {   //Mensaje
            setExptError('Debe seleccionar el Expediente')
            //Retorno
            return false;
        }
        //Armo el objeto de datos
        let data = {
            juez: {
                id: values.juez
            },
            expediente: {
                id: expediente.id
            },
            motivo: {
                id: values.motivo
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(recuse.id)
        {   //Agrego el id
            data = {
                id: recuse.id,
                ...data
            }
            //Es edición
            dispatch( updateRecusesAction(data, handleCloseForm) );
        }
        else
        {   //Es creación
            dispatch( saveRecusesAction(data, handleCloseForm) );
        }
    }

    // Manejo el valor
    const handleSelectLabel = e => {
        if(e)
        {   return `${e.numero} - ${e.caratula}`;
        }
    }

    // Manejo el label
    const handleSelectValue = e => {
        if(e)
        {   return e.id;
        }
    }
    
    // Esquema de validación
    const validationSchema = yup.object({
        expediente: yup.number().nullable(),
        juez: yup.number().required(),
        motivo: yup.number().required()
    });
    
    

    // --------------------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <Modal 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleCloseForm} 
            onShow = { handleOnShow} 
            show = { show} 
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Recusación&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...recuse }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-6">
                                    <label htmlFor="juez">Juez/Magistrado</label>
                                    <Form.Control
                                        as = "select"
                                        autoFocus 
                                        className = "form-control"
                                        disabled = { recusesLoading }
                                        id = "juez"  
                                        isInvalid = { !!errors.juez }
                                        name = "juez" 
                                        onChange = { handleChange }
                                        ref = { refJuez }
                                        value = { values.juez }
                                    >
                                        <option value="">Seleccione un Juez/Magistrado</option>
                                        {   judges 
                                                ?
                                                    judges.map(judge => (
                                                        <option value={judge.id} key={`ij${judge.id}`}>
                                                            { `${judge.apellido}, ${judge.nombre}`  }
                                                        </option>
                                                    ))
                                                :
                                                    null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.juez }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="motivo">Motivo</label>
                                    <Form.Control
                                        as = "select"
                                        className = "form-control" 
                                        disabled = { recusesLoading }
                                        id = "motivo" 
                                        isInvalid = { !!errors.motivo }
                                        name = "motivo" 
                                        onChange = { handleChange }
                                        value = { values.motivo }
                                    >
                                        <option value="">Seleccione el Motivo</option>
                                        {   audienceMotives 
                                                ? 
                                                    audienceMotives.filter(am => am.grupo.descripcion === MOTIVO_RECUSACION).map(audienceMotive => (
                                                        <option value={audienceMotive.id} key={`amr${audienceMotive.id}`}>
                                                            { `${audienceMotive.descripcion}`  }
                                                        </option>
                                                    ))
                                                : 
                                                    null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.motivo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="expediente">Expediente</label>
                                    <AsyncSelect
                                        cacheOptions
                                        className = { exptError && exptError != '' ? 'is-invalid' : '' }
                                        defaultOptions
                                        getOptionLabel = { handleSelectLabel }
                                        getOptionValue = { handleSelectValue }
                                        loadingMessage = { ()=>(`Buscando...`) }
                                        loadOptions = { handleOptions }
                                        noOptionsMessage = { ()=>(`No se encontraron resultados`) }
                                        onChange = { handleChangeExpt }
                                        onInputChange = { handleInputChange }
                                        placeholder = "Buscar expediente..."
                                        value = { expediente }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { exptError }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   recusesLoading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button variant="success" type="submit" disabled={ recusesLoading }>
                                            <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ recusesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default RecuseForm;
